import script from "./index-noleft.vue?vue&type=script&lang=ts&setup=true"
export * from "./index-noleft.vue?vue&type=script&lang=ts&setup=true"

import "./index-noleft.vue?vue&type=style&index=0&id=cdf28b82&lang=scss&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WebWWW\\client-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdf28b82"]])

export default __exports__